import type { NumberMatrix } from "./algorithm.types";

export const zeroArrayTemplate = (
  columns: number,
  rows: number,
): NumberMatrix => [...Array(columns)].map(() => Array(rows).fill(0));

export const sumProduct = (arr1: Array<number>, arr2: Array<number>): number =>
  arr1.reduce((total, value, index) => total + value * arr2[index], 0);

export const dayNumberInData = (
  season: number,
  dayOfTheSeason: number,
  noOfDaysPerSeason: number,
): number => (season - 1) * noOfDaysPerSeason + dayOfTheSeason - 1;
